import trafficApi from './api/trafficApi';
import { objectToQueryString } from '../utils';

const initialState = {
};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const reportList = (payload) => {
  return dispatch => {
    const queryString = objectToQueryString(payload);
    return trafficApi.get(`/report${queryString}`).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };  
}

export const reportRequestCount = (payload) => {
    return dispatch => {
      const queryString = objectToQueryString(payload);
      return trafficApi.get(`/report?requestCount=true${"&" + queryString.slice(1)}`).then(data => {
        return data;
      }).catch(error => {
        throw (error);
      });
    };  
}

export const reportSankey = (payload) => {
  return dispatch => {
    const queryString = objectToQueryString(payload);
    return trafficApi.get(`/report?sankey=true${"&" + queryString.slice(1)}`).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };  
}